/**
 * 从 CSS 变量读取 ECharts 地图配色，与 Dashboard 明暗主题保持一致。
 */
function readCssVar(name, fallback) {
  if (typeof document === 'undefined') return fallback
  const value = getComputedStyle(document.documentElement).getPropertyValue(name).trim()
  return value || fallback
}

function readCssNumber(name, fallback) {
  const parsed = parseFloat(readCssVar(name, String(fallback)))
  return Number.isFinite(parsed) ? parsed : fallback
}

/**
 * @returns {Record<string, string | number>} 当前主题下的地图视觉 token
 */
export function getMapTheme() {
  return {
    areaColor: readCssVar('--map-area', '#0f172a'),
    areaHover: readCssVar('--map-area-hover', '#1e3a5f'),
    areaSelected: readCssVar('--map-area-selected', '#1e40af'),
    borderColor: readCssVar('--map-border', '#3b82f6'),
    borderActive: readCssVar('--map-border-active', '#00f0ff'),
    borderWidth: readCssNumber('--map-border-width', 1),
    borderActiveWidth: readCssNumber('--map-border-active-width', 2),
    labelColor: readCssVar('--map-label', 'rgba(255, 255, 255, 0.25)'),
    labelHover: readCssVar('--map-label-hover', '#ffffff'),
    labelFontSize: readCssNumber('--map-label-size', 10),
    scatterLabel: readCssVar('--map-scatter-label', '#f8fafc'),
    scatterLabelBorder: readCssVar('--map-scatter-label-border', '#000000'),
    tooltipBg: readCssVar('--map-tooltip-bg', 'rgba(15, 23, 42, 0.95)'),
    tooltipBorder: readCssVar('--map-tooltip-border', '#00f0ff'),
    tooltipText: readCssVar('--map-tooltip-text', '#ffffff'),
    tooltipAccent: readCssVar('--map-tooltip-accent', '#00f0ff'),
    tooltipMuted: readCssVar('--map-tooltip-muted', '#94a3b8'),
    scatterShadow: readCssVar('--map-scatter-shadow', 'rgba(0, 0, 0, 0.3)'),
    selectedShadow: readCssVar('--map-selected-shadow', 'rgba(0, 240, 255, 0.4)')
  }
}
